import AXIOS from "./axios";
import axios from "axios";

export class Room {
  static detail(id) {
    return AXIOS.get(`rooms/${id}`);
  }

  static create(id) {
    let headers = JSON.parse(sessionStorage.getItem("headers"));
    return axios.post(
      `${process.env.VUE_APP_API_BASE_PATH}/api/v2/rooms`,
      { room: { appointment_id: id } },
      {
        headers: {
          "access-token": headers["access-token"],
          client: headers.client,
          expiry: headers.expiry,
          "token-type": headers["token-type"],
          uid: headers.uid
        }
      }
    );
  }

  static detailV2(id) {
    let headers = JSON.parse(sessionStorage.getItem("headers"));
    return axios.get(
      `${process.env.VUE_APP_API_BASE_PATH}/api/v2/rooms/${id}`,
      {
        headers: {
          "access-token": headers["access-token"],
          client: headers.client,
          expiry: headers.expiry,
          "token-type": headers["token-type"],
          uid: headers.uid
        }
      }
    );
  }
}
